<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.overview.info.title.shortLabel"
                        | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section></section>
    </mat-card-content>
</mat-card>
